/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

// New thread worker code

export enum EFakeWorkerTypes {
    GLOBE_WORKER,
    DOWNLOAD_WORKER,
    CRUNCH_DECODE_WORKER,
    RESOLUTION_COMPUTE_WORKER
}

export class FakeWorker {
    private readonly workerObject: any;

    constructor(aType: EFakeWorkerTypes, aWorkerObject: object)
    {
        this.workerObject = aWorkerObject;
    }

    public addEventListener(aEventName: string, aCallback: any): void
    {
        if (!this.workerObject) {
            return;
        }

        // this will create a fakeWorkerCallback which is called as a replacement of post message in fake worker
        // @ts-ignore
        this.workerObject.fakeWorkerCallback = aCallback;
    }

    public postMessage(aMessage: {}): void
    {
        if (!this.workerObject) {
            return;
        }

        // prevent call stack size exceeded when laoding model because as as we do not have the async calls to workers, the calls
        // will be otherwise synchronized
        setTimeout((): void => {
            // @ts-ignore
            this.workerObject.acceptMessage({data: aMessage});
        }, 10);
    }
}
